import { render, staticRenderFns } from "./DescriptionLanguagesDialog.vue?vue&type=template&id=56540e54&scoped=true&lang=pug&"
import script from "./DescriptionLanguagesDialog.vue?vue&type=script&lang=ts&"
export * from "./DescriptionLanguagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DescriptionLanguagesDialog.vue?vue&type=style&index=0&id=56540e54&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56540e54",
  null
  
)

export default component.exports